import React from "react";
import {
  Form,
  Select,
  Button,
  Space,
  DatePicker,
  Row,
  Col,
  Checkbox,
  Modal,
  Tooltip,
  Dropdown,
  Image,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import { PlusOutlined } from "@ant-design/icons";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";

import WASLReportListStore from "../store/WASLReportListStore";
import config from "../config";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import VehicleStore from "../store/VehicleStore";
import { decode as base64_decode } from "base-64";
import Cookies from "js-cookie";
import MachineryReportStore from "../store/MachineryReportStore";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";

const { RangePicker } = DatePicker;
dayjs.extend(customParseFormat);

const { Option } = Select;

let widthAdderFunc = (arr) => {
  let array = arr;
  array.map((val) => {
    if (val.title?.length > 24) {
      val.width = 250;
    } else if (val.title?.length > 15) {
      val.width = 200;
    } else if (val.title?.length > 12) {
      val.width = 150;
    } else if (val.title?.length > 8) {
      val.width = 125;
    } else {
      val.width = 110;
    }
    // console.log(val.title.length)
  });

  return arr;
};

class WASLReportList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.machineryReportStore = new MachineryReportStore(this);
    this.waslReportStore = new WASLReportListStore(this);
    this.vehicleStore = new VehicleStore(this);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      company_name: "",
      listUpdated: 0,
      companyId: "",

      selectedVehicles: "",
      selectAllVehicles: false,
      modalVisible: false,
      column: "",
      filter: "",
      showEmail: false,
      fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
      toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      Notcompany: false,
      Notasset: false,

      showMonthPopup: false,
      selectedColumns: widthAdderFunc([
        {
          // title: "Asset Name",
          title: context.translate("_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"),
          dataIndex: "vehicleNo",
          key: "vehicleNo",
          width: "15%",
          ellipsis: true,
        },
        {
          // title: "Vehicle Reference Key",
          title: context.translate("_VEHICLE_REFERENCE_KEY_"),
          dataIndex: "referenceKey",
          key: "referenceKey",
          width: "15%",
          ellipsis: true,
        },
        {
          // title: "Driver Reference Key",
          title: context.translate("_DRIVER_REFERENCE_KEY_"),
          dataIndex: "driverReferenceKey",
          key: "driverReferenceKey",
          width: "15%",
          ellipsis: true,
        },

        {
          // title: "Latitude",
          title: context.translate("_FLEET_DASHBORD_SETTING_LATITUDE_"),
          dataIndex: "latitude",
          key: "latitude",
          width: "15%",
          ellipsis: true,
        },
        {
          // title: "Longitude",
          title: context.translate("_FLEET_DASHBORD_SETTING_LONGITUDE_"),
          dataIndex: "longitude",
          key: "longitude",
          width: "15%",
          ellipsis: true,
        },
        {
          // title: "Velocity",
          title: context.translate("_VELOCITY_"),
          dataIndex: "velocity",
          key: "velocity",
          width: "15%",
          ellipsis: true,
        },
        {
          // title: "Weight",
          title: context.translate("_WEIGHT_"),
          dataIndex: "weight",
          key: "weight",
          width: "15%",
          ellipsis: true,
        },

        {
          // title: "Location Time",
          title: context.translate("_LOCATION_TIME_"),
          dataIndex: "locationTime",
          key: "locationTime",
          width: "15%",
          ellipsis: true,
        },
        {
          // title: "Vehicle Status",
          title: context.translate("_VEHICLE_STATUS_"),
          dataIndex: "vehicleStatus",
          key: "vehicleStatus",
          width: "15%",
          ellipsis: true,
        },
        {
          // title: "Address",
          title: context.translate("_FLEET_DASHBORD_NEWPOI_ADDRESS_"),
          dataIndex: "address",
          key: "address",
          width: "15%",
          ellipsis: true,
        },
        {
          // title: "Role Code ",
          title: context.translate("_ROLE_CODE_"),
          dataIndex: "roleCode",
          key: "roleCode",
          width: "15%",
          ellipsis: true,
        },
        {
          // title: "Response",
          title: context.translate("_RESPONSE_"),
          dataIndex: "waslResponse",
          key: "waslResponse",
          width: "15%",
          ellipsis: true,
        },
        {
          // title: "Status",
          title: context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
          dataIndex: "waslReply",
          key: "waslReply",
          width: "15%",
          ellipsis: true,
        },
        {
          // title: "Posting Time",
          title: context.translate("_POSTING_TIME"),
          dataIndex: "sendAt",
          key: "sendAt",
          width: "15%",
          ellipsis: true,
        },
        {
          // title: "Response Time",
          title: context.translate("_RESPONSE_TIME_"),
          dataIndex: "receivedAt",
          key: "receivedAt",
          width: "15%",
          ellipsis: true,
        },
        {
          // title: "Activity",
          title: context.translate("_ACTIVITY_"),
          dataIndex: "activity",
          key: "activity",
          width: "15%",
          ellipsis: true,
        },
        {
          // title: "Temperature",
          title: context.translate("_FLEET_DASHBORD_SETTING_TEMPERATURE_"),
          dataIndex: "temperature",
          key: "temperature",
          width: "15%",
          ellipsis: true,
        },
        {
          // title: "Humidity",
          title: context.translate("_HUMIDITY_"),
          dataIndex: "humidity",
          key: "humidity",
          width: "15%",
          ellipsis: true,
        },
      ]),
    };

    this.ExportOption = {
      items: [
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={Excel}
              ></Image>
              {context.translate("_EXPORT_AS_EXCEL_")}
            </div>
          ),
          key: "excel",
        },
        {
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Image
                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                src={PDF}
              ></Image>
              {context.translate("_EXPORT_AS_PDF_")}
            </div>
          ),
          key: "pdf",
        },
      ],
      onClick: (val) => {
        let result = [];

        if (true) {
          this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

          var getData = {
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            colList: result.toString(),
            userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
          };

          if (val.key == "excel") {
            this.waslReportStore.exportExcel(getData);
          }
          if (val.key == "pdf") {
            this.waslReportStore.exportpdf(getData);
          }
        }
      },
    };

    this.newColumns = [...this.state.selectedColumns];
  }

  async componentDidMount() {
    this.setState({ pageSize: 50 });
    await this.setState({ column: this.state.selectedColumns });
    if (Number(this.props.getUserData().isadmin) !== -1) {
      let companyId = this.props.getUserData().userCompanyId;

      this.setState({ companyId: companyId });
      this.handleChange({ value: companyId });
    }
  }

  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });

    await this.showData();
  }

  refreshList = async () => {
    await this.setState({ loading: false, current: 1, currentPage: 1 });
    await this.showData();
  };
  async handleChange(comp) {
    await this.setState({ Notcompany: false });
    await this.setState({ currentPage: 1, companyId: comp?.value });
    await this.setState({ selectedVehicles: "", selectAllVehicles: false });
    await this.vehicleStore.getVehiclesCompanyId(comp?.value);
    await this.machineryReportStore.getEmailIds({
      companyId: comp.value,
    });
    await this.setState({ listUpdated: 1 });
    // this.handleSearch();
  }

  async handleSearch() {
    this.setState({ Notasset: false });
    await this.waslReportStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      companyId: this.state.companyId,
    });

    await this.setState({ listUpdated: 1 }); //need to reload data
  }
  addMonths = (date, months) => {
    var indx = dayjs().month() + -6;

    return dayjs().month(indx);
  };
  checkFromDate(dates) {
    var fromDate = dates;
    var pdate = this.addMonths();
    if (pdate > fromDate) {
      this.setState({ showMonthPopup: true });
      return false;
    } else {
      return true;
    }
  }
  onDateTimeChange = (dates) => {
    if (dates) {
      const format = "YYYY-MM-DD HH:mm:ss";
      this.setState({
        fromdateStdTime: dates[0],
        fromDate: dates[0].format(format),
        toDate: dates[1].format(format),
      });
    } else {
      this.setState({ fromDate: "", toDate: "" });
    }
  };
  showData = async () => {
    if (!this.state.companyId) {
      this.setState({ Notcompany: true });
    } else {
      this.setState({ Notcompany: false });
    }
    if (!this.state.selectedVehicles) {
      this.setState({ Notasset: true });
    } else {
      this.setState({ Notasset: false });
    }
    if (this.state.companyId && this.state.selectedVehicles) {
      // this.setState({mandatory:false})
      this.setState({ Notcompany: false, Notasset: false });
      if (this.checkFromDate(this.state.fromdateStdTime)) {
        await this.waslReportStore.loadData({
          offset: (this.state.currentPage - 1) * this.state.pageSize,
          limit: this.state.pageSize,
          companyId: this.state.companyId,
          vehicleId: this.state.selectedVehicles,
          fromDate: this.state.fromDate,

          toDate: this.state.toDate,
          page: this.state.currentPage,
        });
        await this.setState({ listUpdated: 1 });
      }
    }
  };

  handleCheckboxChange = async (column) => {
    if (this.state.selectedColumns.some((c) => c.key === column.key)) {
      const filtered = this.state.selectedColumns.filter(
        (c) => c.key !== column.key
      );

      await this.setState({
        selectedColumns: filtered,
      });
      await this.setState({ column: filtered });
      // await  this.updateVisibleColumns();
    } else {
      await this.setState({
        selectedColumns: [...this.state.selectedColumns, column],
        column: [...this.state.selectedColumns, column],
      });
      // await  this.updateVisibleColumns();
    }
  };

  onEmailSend = async (emailId) => {
    let result = [];
    this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));
    const data = {
      companyId: this.state.companyId,
      vehicleId: this.state.selectedVehicles,
      fromDate: this.state.fromDate,
      toDate: this.state.toDate,
      emailIds: emailId.Email,
      colList: result.toString(),
      userName: this.props.getUserData().userName,
    };

    const response = await this.waslReportStore.sendExcelByEmail(data);

    console.log(response, "sdfghhhhhhh");
    // var data = {};
    //                            data.companyId = this.companyCombo.getValue();
    //                            data.vehicleId = this.vehicleCombo.getValue();
    //                            data.emailIds = this.EmailCombo.getValue();
    //                           // data.intervel = this.intervelCombo.getValue();
    //                           // data.filter = this.filterCombo.getValue();
    //                            data.username = Ext.getStore('userStore').first().get('name');
    //                            data.fromDate = Ext.Date.format(this.fromDate.getValue(), "Y-m-d") + ' ' + Ext.Date.format(this.FromTime.getValue(), 'H:i:s');
    //                            data.toDate = Ext.Date.format(this.toDate.getValue(), "Y-m-d") + ' ' + Ext.Date.format(this.ToTime.getValue(), 'H:i:s');
    //                            data.colList = this.GridColumns.toString();
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Space>
              <CompanyAutocomplete
                className="searchInput"
                allowClear={true}
                onChange={(value) => this.handleChange(value)}
                style={{ width: 150 }}
                status={this.state.Notcompany ? "error" : false}
              />

              <Select
                value={
                  this.state.selectedVehicles
                    ? this.state.selectedVehicles
                    : null
                }
                onChange={(val) => {
                  this.setState({ selectedVehicles: val });
                  this.setState({ Notasset: false });
                }}
                className="searchInput"
                style={{ width: 150 }}
                showSearch
                status={this.state.Notasset ? "error" : false}
                placeholder={this.context.translate(
                  "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                )}
                filterOption={(inputValue, option) => {
                  if (option.children) {
                    return (
                      option.children
                        .toLowerCase()
                        .indexOf(inputValue.toLowerCase()) >= 0
                    );
                  }
                }}
              >
                {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                  return (
                    <Option key={val.vehicleId} value={val.vehicleId}>
                      {val.vehicleNo}
                    </Option>
                  );
                })}
              </Select>

              <RangePicker
                placeholder={["From Datetime", "To Datetime"]}
                format="DD-MM-YYYY hh:mmA"
                style={{ width: 400, borderRadius: "25px" }}
                onChange={(val) => {
                  this.onDateTimeChange(val);
                }}
                disabledDate={(current) => {
                  return current && current > dayjs();
                }}
                showTime={{
                  format: "h:mmA",
                  defaultValue: [dayjs().startOf("day"), dayjs()],
                }}
                defaultValue={[dayjs().startOf("day"), dayjs()]}
              />

              <Button
                type="primary"
                onClick={async () => {
                  await this.setState({ currentPage: 1, pageSize: 50 });
                  await this.showData();
                }}
              >
                {this.context.translate("_FLEET_SHOW_BTN_")}
              </Button>

              <Button onClick={() => this.setState({ modalVisible: true })}>
                {this.context.translate("_COLUMNS_")}
              </Button>
              {/* <Button
                // style={{ backgroundColor: config.activeColor }}
                onClick={() => this.setState({ showEmail: true })}
                disabled={
                  this.state.companyId && this.state.selectedVehicles
                    ? false
                    : true
                }
              >
                {" "}
                Email
              </Button> */}
            </Space>
            <Space
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
            >
              <Space>
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      marginInlineEnd: "20px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  />
                </Tooltip>
                <Button
                  className="downloadExcelButton"
                  disabled={
                    this.waslReportStore?.waslReportList?.length > 0
                      ? false
                      : true
                  }
                >
                  <Dropdown
                    overlayClassName="export-dropdown"
                    menu={this.ExportOption}
                  >
                    <Image
                      style={{
                        height: 18,
                        alignItems: "center",
                        marginInlineEnd: "30px",
                      }}
                      src={downloadIcon}
                    ></Image>
                  </Dropdown>
                </Button>
              </Space>
            </Space>
          </Row>

          <Modal
            open={this.state.modalVisible}
            width={250}
            title={this.context.translate("_SELECT_COLUMNS_")}
            onCancel={() => this.setState({ modalVisible: false })}
            onOk={() => {
              this.setState({ modalVisible: false });
            }}
            footer={null}
          >
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {this.newColumns.map((column, v) => {
                return (
                  <Row key={v}>
                    <Col>
                      <Checkbox
                        onChange={() => this.handleCheckboxChange(column)}
                        checked={this.state.selectedColumns.some(
                          (c) => c.key === column.key
                        )}
                      >
                        {column.title}
                      </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </div>
          </Modal>

          <Modal
            width={350}
            className="alert-model"
            title={
              <div>
                {" "}
                <i
                  style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                  class="bi bi-exclamation-triangle"
                ></i>{" "}
                {this.context.translate("_FLEET_ALERT_")}
              </div>
            }
            open={this.state.showMonthPopup}
            onOk={() => this.setState({ showMonthPopup: false })}
            onCancel={() => this.setState({ showMonthPopup: false })}
            footer={false}
          >
            {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
          </Modal>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.waslReportStore?.total}
            columns={this.state.column}
            dataSource={this.waslReportStore?.waslReportList}
            loading={this.waslReportStore?.loading}
            onChange={this.handleTableChange}
          />

          <Modal
            open={this.state.showEmail}
            title={this.context.translate("_SEND_EMAIL_")}
            onOk={() => this.setState({ showEmail: false })}
            onCancel={() => this.setState({ showEmail: false })}
            footer={false}
            width={400}
          >
            <Form
              name="Email"
              layout="vertical"
              onFinish={this.onEmailSend}
              style={{ maxWidth: "100%" }}
            >
              <Form.Item
                name="Email"
                title={this.context.translate("_FLEET_LOGIN_EMAILLBL_")}
                rules={[{ required: true }]}
              >
                <Select
                  mode="multiple"
                  maxTagCount={"responsive"}
                  fieldNames={{ label: "emailIds", value: "emailIds" }}
                  placeholder={this.context.translate("_EMAIL_IDS_")}
                  optionFilterProp="children"
                  options={this.machineryReportStore?.emailIdsList}
                  style={{ width: 355 }}
                />
              </Form.Item>
              <div className="formBtnGroup">
                <Button
                  type="primary"
                  className="formSaveButton"
                  htmlType="submit"
                >
                  {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                </Button>
              </div>
            </Form>
          </Modal>
        </div>
      </>
    );
  }
}
WASLReportList.contextType = StoreContext;
export default observer(withRouter(WASLReportList));
